import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkFlowReportService } from '../../../../../services/workflowreport.service';
import { DialogImageComponent } from '../../../dialog-image/dialog-image.component';

@Component({
  selector: 'wdm-multi-capture-report',
  templateUrl: 'multi-capture-report.component.html',
  styleUrls: ['multi-capture-report.component.scss']
})

export class MultiCaptureReportComponent implements OnInit {

  @Input() stepinfo: any;
  images: MultiCaptureReportResult[] = [];

  constructor(public workFlowReportService: WorkFlowReportService, public dialog: MatDialog) {

  }

  ngOnInit() {
    this.images = JSON.parse(this.stepinfo.result);
  }

  openImage(imageURL: string) {

    const dialogImage = this.dialog.open(DialogImageComponent, {
      width: '90%',
      data: {
        img: imageURL,
      }
    });
  }

}


interface MultiCaptureReportResult {
    ImageUrl: string;
    ImageName: string;
    Index: number;
}
